import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { updateMappingsAPI } from '../apis';

const useUpdateMappings = (payload) => {
  const mutationAction = useMutation({
    mutationFn: updateMappingsAPI,
    onSuccess: () => {
      toast.success('Update successfully');
      payload?.callbackSuccess();
    },
    onError: (error) => {
      const message = error?.response?.data?.message ?? 'Server error';
      toast.error(message);
      console.error('Error update mapping :', error);
    },
  });

  return mutationAction;
};

export default useUpdateMappings;
